import type { Schemas } from '#shopware'

export const calculatedPriceIncludes: Schemas['Includes'] = {
    calculated_price: ['unitPrice', 'listPrice', 'calculatedTaxes', 'regulationPrice'],
    cart_list_price: ['discount', 'percentage', 'price'],
    cart_tax_calculated: ['tax', 'taxRate'],
    cart_regulation_price: ['price'],
}

